import React from "react";
import { observer } from "mobx-react";
import { Button } from "@components/buttons";

interface PaginationButtonProps {
	direction: "prev" | "next";
	onClick: () => void;
	disabled: boolean;
	label: string;
}

export const QuickPlayPaginationButton = observer(
	function QuickPlayPaginationButton(props: PaginationButtonProps) {
		const isPrev = props.direction === "prev";

		return (
			<Button
				onClick={props.onClick}
				switchIcon
				type="button"
				disabled={props.disabled}
				className="popup--most__btn popup--most__btn--secondary btn--focus-reset btn--med btn--primary--inverted"
				iconClassName={`u-icon--tny ${isPrev ? "u-icon--arrow-left" : "u-icon--arrow-right"}`}
				iconLeft={isPrev}
				iconRight={!isPrev}
				loaderClassName="btn--load--primary"
				btnText={props.label}
			/>
		);
	}
);
